import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/Form.css';
import '../assets/css/Responsiveness.css';
import logo from '../assets/images/Logo.svg';
import cookie from 'react-cookies';
import { Button, Col, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../store/authentication/async-actions';
// import { push } from 'connected-react-router';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import Spinner from './UI/Spinner/Spinner';
import { ReqPost, globalEnv } from '../config/Requests';
import { MdRemoveRedEye } from 'react-icons/md';
import { Api } from '../config/Api';
import { majorVersion, minorVersion } from '../helper/version';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom/cjs/react-router-dom';

function Login(props) {
	const navigate = useNavigate();
	const url = window.location.href;
	const getInitValues = () => {
		const obj = {
			remember_me: false,
			email: '',
			password: '',
		};

		if (cookie.load('remember_me') && cookie.load('email') !== '') {
			obj.remember_me = cookie.load('remember_me');
			obj.email = cookie.load('email');
			obj.password = cookie.load('password');
		}
		return obj;
	};

	const initialValues = getInitValues();

	const dispatch = useDispatch();

	// const loginUser = values => dispatch(loginUser(values))
	// push: path => dispatch(push(path)),

	const validationSchema = Yup.object().shape({
		password: Yup.string().required('*Password is required'),
		email: Yup.string()
			.email('*Must be a valid email address')
			.max(100, '*Email must be less than 100 characters')
			.required('*Email is required'),
	});

	const RedirectToTwitter = () => {
		const reqApi = Api('serv', globalEnv);
		const newWindow = window.open(
			`${reqApi}/redirect/twitter`,
			'_self',
			'noopener,noreferrer'
		);
		if (newWindow) newWindow.opener = null;
	};

	const formSubmit = async values => {
		if (values.remember_me) {
			cookie.save('remember_me', values.remember_me, { path: '/' });
			cookie.save('email', values.email, { path: '/' });
			cookie.save('password', values.password, { path: '/' });
		} else {
			cookie.remove('remember_me', { path: '/' });
			cookie.remove('email', { path: '/' });
			cookie.remove('password', { path: '/' });
		}

		// loginUser(values)

		try {
			let fromSocialMedial;
			let res;
			if (fromSocialMedial) {
				res = values;
			} else {
				res = await ReqPost('login', values);

				if (res.status === 201) {
					localStorage.setItem('cogen_user_profile', JSON.stringify(res.data));
					if (
						res.data.message === 'You are not subscribed.' ||
						res.data.message === 'Your account has not been configured.' ||
						res.data.success == false
					) {
						navigate('/stripe');
						return;
					}
					if (
						res.data.user.yearAgo == 1 &&
						res.data?.user?.user_type == 'client'
					) {
						navigate('/client-plans');
						return;
					}
					if (
						res.data.user.yearAgo == 1 &&
						res.data?.user?.user_type == 'member'
					) {
						navigate('/member-plans');
						return;
					}
					// dispatch(loginSuccess(res.data));
					if (url.includes('subscribe')) {
						// props.push('')
						navigate('/subscribe');
						return;
					} else {
						// props.push('/');
						navigate('/');
						// toast.success('Login success');
						navigate(0);
					}
				} else if (res.data.code === 406) {
					toast.error('invalid crdentials');
					return;
				}
			}
		} catch (err) {
			if (err?.response?.data?.status) {
				return toast.error(err.response.data.status);
			} else {
				return toast.error(`Something went wrong`);
			}
			// dispatch(loginFailed(err.message))
		}
	};
	var state = false;
	function toggle() {
		if (state) {
			document.getElementById('password').setAttribute('type', 'password');
			document.getElementById('eye').style.color = '#7a797e';
			state = false;
		} else {
			document.getElementById('password').setAttribute('type', 'text');
			document.getElementById('eye').style.color = '#5887ef';
			state = true;
		}
	}
	// const [show, setShow] = useState(false);

	// const handleClose = () => setShow(false);
	// const handleShow = () => setShow(true);
	const isAuth = useSelector(state => state.auth.isSuccess);
	const initiated = useSelector(state => state.auth.isInitiated);
	return (
		<React.Fragment>
			<div className='main-container form-bg-color form-bg-log'>
				<img src={logo} className='form-logo' alt='logo' />
				<div className='form-container'>
					<div className='form-label-header'>Welcome Aboard Cogen!</div>
					<Formik
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={(values, { setSubmitting, resetForm }) => {
							formSubmit(values, setSubmitting, resetForm);
						}}
					>
						{({ errors, touched, values, handleSubmit, isSubmitting }) => (
							<Form className='form-container-inner' onSubmit={handleSubmit}>
								<Field
									name='email'
									type='email'
									placeholder='Email'
									className={`${
										errors.email && touched.email ? 'error' : ''
									} form-input`}
									style={{ outline: 'none' }}
								/>
								{errors.email && touched.email ? (
									<div className={`red mb-1 fs15`} style={{ color: 'red' }}>
										{errors.email}
									</div>
								) : null}
								<Field
									name='password'
									type='password'
									id='password'
									placeholder='Password'
									className={`${
										errors.password && touched.password ? 'error' : ''
									} form-input`}
									style={{ outline: 'none' }}
								/>
								<MdRemoveRedEye
									className='removeEye'
									onClick={toggle}
									id='eye'
								/>
								{errors.password && touched.password ? (
									<div className={`red mb-1 fs15`} style={{ color: 'red' }}>
										{errors.password}
									</div>
								) : null}

								<Col
									style={{
										color: ' #000',
										fontSize: '14px',
										display: 'flex',
										justifyContent: 'flex-start',
										marginLeft: '14px',
										marginBottom: '12px',
										marginTop: '12px',
									}}
								>
									<Field type='checkbox' name='remember_me' />
									<span className='pl-1'>&nbsp;Remember me</span>
								</Col>
								{initiated && <Spinner />}
								<Button
									type='submit'
									className='btn-login'
									style={{ fontWeight: 'bold', borderRadius: '30px' }}
								>
									LOGIN
								</Button>
								{/* <Button className="btn-login mt-2" onClick={RedirectToTwitter}>Login with Twitter</Button> */}
								<Link to='/forgot-password' className='btn-forgot'>
									Forgot Password{' '}
								</Link>
								<span className='text-link-to'>
									Not Registered?{' '}
									<Link to='/registration' className='btn-link'>
										<strong style={{ fontWeight: 'bold' }}>Sign up </strong>
									</Link>{' '}
								</span>
							</Form>
						)}
					</Formik>

					<p style={{ color: 'hsl(212deg 75% 51%)', fontSize: '12px' }}>
						{' '}
						<b>v{majorVersion + '.' + minorVersion}</b>
					</p>
				</div>
			</div>

			{/* <div>
      <Modal size="sm" show={show} onHide={handleClose} className="close">
          <Modal.Header className="no-border text-center">
            <Modal.Title className="modal-title w-100 font-weight-bolder">Pay Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center"> For again subscription, Please pay your payment. otherwise your account will be blocked within 30 days.</Modal.Body>
          <Modal.Footer className="no-border">
            <Button className="w-100  font-weight-bold btn-logout" variant="primary">
              Subscription
            </Button>
            <Button className="w-100 font-weight-bold btn-logout" variant="danger">
              CANCEL
            </Button>
          </Modal.Footer>
        </Modal>
        </div> */}
		</React.Fragment>
	);
}

export default Login;
